<template>
    <div>
        <van-row :gutter="10" @click="goto('/fooddetail',item)">
            <van-col :span="7" class="img">
                <img :src="$baseurl+item.img" />
            </van-col>
            <van-col :span="17" class="fborder" >
                <van-row class="fmargin">
                    <van-col :span="24" >
                    <span class="mtit">{{item.title}}</span>
                    </van-col>  
                </van-row>
                <van-row class="fmargin fs fontent">
                    <van-col :span="24">
                        <van-row :gutter="12">
                            <span class="gmm">
                                <van-icon  color="#04e60f"  v-if="item.eatYunQi==0" name="checked" class="iconset" size="14"/>
                                <van-icon  :color="$abctheme.basecolor"  v-if="item.eatYunQi==1||item.eatYunQi==2" name="warning" class="iconset" size="14"/>
                                <van-icon  color="red"  v-if="item.eatYunQi==3" name="clear" class="iconset" size="14"/>
                                <span>孕期</span>
                            </span>
                            <span class="gmm">
                                <van-icon color="#04e60f"  v-if="item.eatYueZi==0" name="checked" class="iconset" size="14"/>
                                <van-icon :color="$abctheme.basecolor"  v-if="item.eatYueZi==1||item.eatYueZi==2" name="warning" class="iconset" size="14"/>
                                <van-icon color="red"  v-if="item.eatYueZi==3" name="clear" class="iconset" size="14"/>
                                <span>坐月子</span>
                            </span>
                            <span class="gmm">
                                <van-icon  color="#04e60f"   v-if="item.eatBuRuQi==0" name="checked" class="iconset" size="14"/>
                                <van-icon :color="$abctheme.basecolor"  v-if="item.eatBuRuQi==1||item.eatBuRuQi==2" name="warning"  class="iconset" size="14"/>
                                <van-icon color="red"  v-if="item.eatBuRuQi==3" name="clear" class="iconset" size="14"/>
                                <span>哺乳期</span>
                           </span>
                        </van-row>
                    </van-col>
                </van-row>
                <van-row class="fmargin fs ffwz">
                    <van-col :span="24">
                        {{item.eatBaoBao}}
                    </van-col>
                </van-row>
            </van-col>
        </van-row>
    </div>
</template>
<script>
export default {
    name:'foodcom',
    props: {
        item: Object,
    },
    methods:{
        goto(url,item){
            this.$router.push({path:url,query:{id:item.id}});
        }
    }
}
</script>
<style lang="scss" scoped>
.img img{
    border-radius: 4px;
    width: 100px;
    height: 70px;
}
.fborder{
    min-height: 70px;
    border-bottom:1px solid #dedede;
}
.ffz .fborder:last-child{
    border-bottom:none;
}

.mtit{
    font-size: 16px;
    font-weight: 500;
}
.mainwz{
    line-height: 20px;
}
.iconset{
    margin-right: 3px;
    display: inline-block;
    vertical-align: -2px;
}
.fmargin{
    margin-bottom: 5px;
}
.fontent{
    margin-top:6px;
}
.fs{
    margin-bottom: 8px;
}

.ffwz{
    font-size: 12px;
    color:#797979;
}
.gmm{
    margin-right: 10px;
}
</style>